import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { ViUIService } from '../../services/ui.service';

export enum SideNavMode {
  over = 'over',
  push = 'push',
  side = 'side',
}
@Component({
  selector: 'vi-sidenav',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatIconModule, MatButtonModule],
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViSidenavComponent {
  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  constructor(public ui: ViUIService) {}

  onClick(): void {
    this.close.emit();
    this.ui.sidenav$.next();
  }
}
